import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { RestApiService } from '../common-app/service/rest-api.service';
import { SharedService } from '../common-app/service/shared.service';
import { Kvaw0300Vo } from './kvaw0300.vo';
import { Constants } from '../constants/constants';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW0300（共通データ取得）.xlsx
 */
@Injectable()
export class Kvaw0300Service {

  /** 検索対象 */
  private static TARGET = 'kvaw0300';

  constructor(
    private restApiService: RestApiService,
    private sharedService: SharedService,
  ) { }

  /**
   * 共通データ一覧を取得する
   */
  searchShareData(): Observable<Kvaw0300Vo> {
    if (this.sharedService.get(Constants.SHARED_DATA_KEY_KVAW0300_API_RESULT) != null) {
      return Observable.of(this.sharedService.get(Constants.SHARED_DATA_KEY_KVAW0300_API_RESULT));
    }

    const param = {};
    return this.restApiService.search<Kvaw0300Vo>(Kvaw0300Service.TARGET, param)
      .map((responseVo) => {
        this.sharedService.set(Constants.SHARED_DATA_KEY_KVAW0300_API_RESULT, responseVo);
        return responseVo;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw0300.service.ts